import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import { menuItem } from '../../../templates/menu/menu.behaviour';

Alpine.plugin(intersect);
Alpine.plugin(focus);

Drupal.behaviors.alpinejs = {
  isStarted: false,

  attach() {
    this.registerEvents();
    this.start();
  },

  /**
   * Register custom Alpine data functions.
   */
  alpineData() {
    menuItem();
  },

  start() {
    this.alpineData();

    if (this.isStarted === false) {
      Alpine.start();
      window.Alpine = Alpine;
    }
  },

  registerEvents() {
    document.addEventListener('alpine:initialized', () => {
      if (this.isStarted === false) {
        this.isStarted = true;
      }
    });
  },
};
